import React from 'react'

var THREE = require('three');


var camera, scene, renderer, geometry, particles, height_bound, width_bound;
var amount = 100,
    radius = 500;

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize( window.innerWidth, window.innerHeight );
  width_bound = height_bound * window.innerWidth / window.innerHeight;
}

function animate() {
  requestAnimationFrame( animate );
  spicy_bikes();
}

const zero_v = new THREE.Vector3(0,0,0);

function spicy_bikes() {
  for (var i = 0; i < scene.children.length; i ++ ) {
    var object = scene.children[ i ];
    if ( object instanceof THREE.Points ) {
      object.position.y -= 3;
      if (object.position.y <= -height_bound){
          object.position.y = height_bound;
      }
    }
  }
  renderer.render( scene, camera );
}


export default class Overlaid extends React.Component {
  init() {
    camera = new THREE.PerspectiveCamera( 60, window.innerWidth / window.innerHeight, 1, 2000 );
    height_bound = Math.tan( 1.0472 / 2) * 1500;
    width_bound = height_bound * window.innerWidth / window.innerHeight;
    camera.position.z = 1500;

    scene = new THREE.Scene();

    var textureLoader = new THREE.TextureLoader();
    var bike_texture = textureLoader.load( "../imgs/easteregg/bike.png" ),
        pepper_texture = textureLoader.load( "../imgs/easteregg/pepper.png" );


    for ( var a = 0; a < 100; a++ ) {
      var geometry = new THREE.Geometry();
      var vertex = new THREE.Vector3();
      vertex.x = 0;
      vertex.y = 0;
      vertex.z = 0;
      geometry.vertices.push( vertex );


      if (Math.random() <= .5) { //Bike
        var material = new THREE.PointsMaterial( { size: Math.random()*210 + 100,
                                                    map: bike_texture,
                                                    blending: THREE.AdditiveBlending,
                                                    depthTest: false,
                                                    transparent : true } ),
            particle = new THREE.Points( geometry, material);
        particle.position.x = Math.random() * width_bound*2 - width_bound;
        particle.position.y = Math.random() * height_bound*2 - height_bound;
        scene.add( particle );
      } else {
        var material = new THREE.PointsMaterial( { size: Math.random()*120 + 60,
                                                    map: pepper_texture,
                                                    blending: THREE.AdditiveBlending,
                                                    depthTest: false,
                                                    transparent : true } ),
            particle = new THREE.Points( geometry , material);
        particle.position.x = Math.random() * width_bound*2 - width_bound;
        particle.position.y = Math.random() * height_bound*2 - height_bound;
        scene.add( particle );
      }
  	}


    // renderer = new THREE.WebGLRenderer();
    renderer = new THREE.WebGLRenderer({alpha:true});
    renderer.setPixelRatio( window.devicePixelRatio );
    renderer.setSize( window.innerWidth, window.innerHeight );
    renderer.setClearColor( 0xffffff, 0);

    var canv = document.getElementById('spicy-canvas-div');
    renderer.domElement.id = 'spicy-bikes';
    console.log(renderer.domElement)
    canv.appendChild( renderer.domElement );
    window.addEventListener( 'resize', onWindowResize, false );
    canv.addEventListener( 'click', this.props.spicePass, false );
  }


  componentDidMount() {
      this.init();
      animate();
    }

  render() {
    return (
      <div id="spicy-canvas-div">
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/3d_overlay.js